import * as React from 'react';

const UserOutlineIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10C10.2091 10 12 8.20914 12 6C12 3.79086 10.2091 2 8 2C5.79086 2 4 3.79086 4 6C4 8.20914 5.79086 10 8 10Z"
      stroke="white"
      strokeMiterlimit="10"
    />
    <path
      d="M1.93681 13.4994C2.55154 12.4354 3.43545 11.5519 4.49974 10.9376C5.56404 10.3234 6.77124 9.99999 8.00007 10C9.22891 10 10.4361 10.3234 11.5004 10.9377C12.5647 11.552 13.4486 12.4355 14.0633 13.4995"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserOutlineIcon;
